import React, { Suspense } from "react";
import { Switch, Route, BrowserRouter, HashRouter } from "react-router-dom";

import { Spinner } from "react-bootstrap";
import web from "../pages/web";

export default () => (
  <BrowserRouter>
    <Suspense
      fallback={
        <div className="text-center" style={{ marginTop: "calc(30vh)" }}>
          <Spinner animation="border" />
        </div>
      }
    >
      <Switch>
        <Route path="/" component={web} />
      </Switch>
    </Suspense>
  </BrowserRouter>
);
